document.addEventListener("DOMContentLoaded", (event) => {
    const fiveSliderImgArray = document.querySelectorAll('.merchandize__products-featured-grid.five-product-grid .product-item__image-wrapper');
    const sixSliderImgArray = Array.from(document.querySelectorAll('.merchandize__products-featured-grid.six-product-grid .product-item__image-wrapper'));

    /* Fixing the height of images in Featured grid slider (when more than 2 in a row) */
    const fixImageHeight = (images) => {
        let smallestImgHeight = images[0].clientHeight;
        images.forEach((image,) => {
            if (image.clientHeight < smallestImgHeight) smallestImgHeight = image.clientHeight;
        })
        images.forEach((image) => {
            if (image.clientHeight > smallestImgHeight)
                image.style.height = smallestImgHeight + 'px';
        })
    }

    /* Fixing the height of images in Featured grid slider (when 2 in a row) */
    if (fiveSliderImgArray.length) {
        if (fiveSliderImgArray[0].clientHeight > fiveSliderImgArray[1].clientHeight) {
            fiveSliderImgArray[0].style.height = fiveSliderImgArray[1].clientHeight + 'px';
        } else if (fiveSliderImgArray[0].clientHeight < fiveSliderImgArray[1].clientHeight)
            fiveSliderImgArray[1].style.height = fiveSliderImgArray[0].clientHeight + 'px';
    }

    if (sixSliderImgArray.length && window.innerWidth >= 1024) {
        fixImageHeight(sixSliderImgArray.slice(0, 3));
        fixImageHeight(sixSliderImgArray.slice(Math.max(sixSliderImgArray.length - 3, 0)));
    }

    if (fiveSliderImgArray.length && window.innerWidth >= 1450) {
        fixImageHeight(fiveSliderImgArray.slice(Math.max(fiveSliderImgArray.length - 3, 0)));
    }
})



